export enum OfflineImportFileType {
    None,
    Items,
    Patrons,
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/enums/offline-import-file-type.enum.ts